import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import find from 'lodash/find'
import moment from '../../../../lib/moment.js'
import { TabPane } from 'reactstrap'
import { StickyContainer, Sticky } from 'react-sticky'
import { timesheetSelector } from '../../../../selectors'
import CategoryButton from './category-button'
import StatusTable from './table'
import RemarkRow from './remark-row'
import { Searchbar } from '../../search-bar'
import { Statusbar } from '../../status-bar'
import { HourRow } from './hour-row'
import { DataRow } from './data-row'
import { StatusRow } from './status-row'
import { Leave } from '../../form/show-leave'
import { Compensate } from '../../form/show-compensate'
import { Holiday } from '../../form/show-holiday'
import * as CONSTANTS from '../../constants'
import * as timesheetHelper from '../../helpers/timesheet'

const TimesheetStatus = class extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'timesheetStatus.timesheetStatus'))
    !== JSON.stringify(prevState.defaultTimesheetStatus)
    && get(nextProps, 'timesheets.users')) {
      const timesheetStatus = get(nextProps, 'timesheetStatus.timesheetStatus', [])
      const users = get(nextProps, 'timesheets.users', [])
      const newTimesheetStatus = timesheetStatus.map(item => {
        const data = find(users, {
          _id: item.user_id,
        })
        const newStatus = {}
        newStatus._id = get(item, 'timesheet_request_id', '')
        newStatus.status = item.status !== CONSTANTS.NONSUBMIT ? item.status : CONSTANTS.UNSUBMITTED
        newStatus.approve_status = item.approve_status
        newStatus.month = item.month
        newStatus.emp_code = data.emp_code
        newStatus.first_name = data.first_name
        newStatus.last_name = data.last_name
        newStatus.nick_name = data.nick_name
        newStatus.lob_name = data.lob_name
        newStatus.department_name = data.department_name
        return newStatus
      })
      set(tempState, 'timesheetStatus', newTimesheetStatus)
      set(tempState, 'defaultTimesheetStatus', timesheetStatus)
    }
    return tempState
  }

  state={
    defaultTimesheetStatus: [],
    timesheetStatus: [],
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(get(nextProps, 'timesheetStatus'))
    === JSON.stringify(this.state.defaultTimesheetStatus)
    && nextState.filterButton === this.state.filterButton) return false
    return true
  }

  showRequestDetail = (dataType, data) => {
    if (dataType === CONSTANTS.HOLIDAY || dataType === CONSTANTS.COMPENSATE) {
      this.setState({ dataType, data: this.changeDataFormat(dataType, data) })
    } else {
      this.setState({ dataType: CONSTANTS.LEAVE, data: this.changeDataFormat(dataType, data) })
    }
  }

  changeDataFormat = (dataType, data) => {
    switch (dataType) {
      case CONSTANTS.HOLIDAY: {
        const holiday = {}
        holiday.holiday_name = get(data, 'description')
        return holiday
      }
      case CONSTANTS.COMPENSATE: {
        const users = get(this.props, 'timesheets.users', [])
        const projects = get(this.props, 'timesheets.projects', [])
        const compensates = []

        data.map(d => {
          const compensate = {}
          const user = timesheetHelper.findUserData(get(d, 'user_id'), users)
          const approver = timesheetHelper.findUserData(get(d, 'approver_id'), users)
          const project = timesheetHelper.findUserData(get(d, 'project_id'), projects)
          compensate.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
          compensate.project = project ? `${project.project_code} - ${project.name}` : '-'
          compensate.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
          compensate.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
          compensate.working_time = get(d, 'compensate_time')
          compensate.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
          compensate.status = get(d, 'status')
          compensate.remark_request_user = get(d, 'remark_request_user')
          compensate.remark_approver = get(d, 'remark_approver')
          compensate.remark_cancel = get(d, 'remark_cancel')
          compensates.push(compensate)
          return d
        })
        return compensates
      }
      default: {
        const users = get(this.props, 'timesheets.users', [])
        const leaveTypes = get(this.props, 'leaveTypes', [])
        const leaves = []

        data.map(d => {
          const leave = {}
          const user = timesheetHelper.findUserData(get(d, 'user_id'), users)
          const approver = timesheetHelper.findUserData(get(d, 'approver_id'), users)
          const leave_type = timesheetHelper.findUserData(get(d, 'leave_type_id'), leaveTypes)
          leave.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
          leave.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
          leave.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
          leave.leave_type = get(leave_type, 'name')
          leave.leave_time = get(d, 'leave_time')
          leave.created = moment(get(d, 'created')).format('DD/MM/YYYY')
          leave.days = get(d, 'days')
          leave.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
          leave.status = get(d, 'status')
          leave.attachment_url = get(d, 'attachment_url')
          leave.remark_request_user = get(d, 'remark_request_user')
          leave.remark_approver = get(d, 'remark_approver')
          leave.remark_hr = get(d, 'remark_hr')
          leave.remark_cancel = get(d, 'remark_cancel')
          leaves.push(leave)
          return d
        })
        return leaves
      }
    }
  }

  handleClickCell = (dataType, data) => {
    this.setState({ showDetail: !this.state.showDetail })
    if (!this.state.showDetail) {
      this.showRequestDetail(dataType, data)
    } else {
      this.setState({ dataType: null, data: {} })
    }
  }

  createTimesheetStatusList = () => {
    const timesheetStatus = this.state.timesheetStatus
    const users = get(this.props, 'timesheets.users', [])
    const newTimesheetStatus = timesheetStatus.map(item => {
      const data = timesheetHelper.findUserData(item.user_id, users)
      const newStatus = {}
      newStatus._id = get(item, 'timesheet_request_id', '')
      newStatus.status = item.status !== CONSTANTS.NONSUBMIT ? item.status : CONSTANTS.UNSUBMITTED
      newStatus.approve_status = item.approve_status
      newStatus.month = item.month
      newStatus.emp_code = data.emp_code
      newStatus.first_name = data.first_name
      newStatus.last_name = data.last_name
      newStatus.nick_name = data.nick_name
      newStatus.lob_name = data.lob_name
      newStatus.department_name = data.department_name
      return newStatus
    })
    return newTimesheetStatus
  }

  filterTimesheetStatus = (searchStatus) => {
    const timesheetStatus = this.state.timesheetStatus
    return timesheetStatus.filter(item => {
      const emp_code = get(item, 'emp_code', '').toLowerCase()
      const status = get(item, 'status', '').toLowerCase()
      const name = (`${get(item, 'first_name', '')} ${get(item, 'last_name', '')} (${get(item, 'nick_name', '')})`).toLowerCase()
      const lob = get(item, 'lob_name', '').toLowerCase()
      const department = get(item, 'department_name', '').toLowerCase()
      const search = searchStatus.toLowerCase()
      return status.includes(search) || emp_code.includes(search) || name.includes(search)
        || lob.includes(search) || department.includes(search)
    })
  }
  /* eslint no-underscore-dangle: 0 */
  render() {
    const { handleClickRequestRow, searchStatus } = this.props
    let timesheetStatus = this.filterTimesheetStatus(searchStatus)

    switch (get(this.props, 'getOptionsTimesheetStatus.filterButtonStatus')) {
      case 2:
        timesheetStatus = timesheetStatus.filter(
          (element) => element.status === CONSTANTS.UNSUBMITTED)
        break
      case 3:
        timesheetStatus = timesheetStatus.filter(
          (element) => element.status === CONSTANTS.PENDING)
        break
      case 4:
        timesheetStatus = timesheetStatus.filter(
          (element) => element.status === CONSTANTS.APPROVED)
        break
      case 5:
        timesheetStatus = timesheetStatus.filter(
          (element) => element.status === CONSTANTS.REJECTED || element.status === CONSTANTS.CANCEL)
        break
      default:
        break
    }

    switch (get(this.props, 'location', '')) {
      case `/time_sheet/status/${get(this.props, 'path')}` : {
        return (
          <TabPane tabId={ 3 }>
            <Content>
              <Leave
                showDetail={ this.state.dataType === CONSTANTS.LEAVE }
                handleDetail={ this.handleClickCell }
                data={ this.state.data }
              />
              <Compensate
                showDetail={ this.state.dataType === CONSTANTS.COMPENSATE }
                handleDetail={ this.handleClickCell }
                data={ this.state.data }
              />
              <Holiday
                showDetail={ this.state.dataType === CONSTANTS.HOLIDAY }
                handleDetail={ this.handleClickCell }
                { ...this.state.data }
              />
              <StickyContainer
                className="container relative"
                id='printContainer'
              >
                <Statusbar { ...this.props } />
                <RemarkRow { ...this.props } />
                <Sticky relative={ true }>
                  {({ style }) => (
                    <Div style={ style }>
                      <Searchbar
                        { ...this.props }
                        searchApprovalDetail={ this.state.searchApprovalDetail }
                        handleSearch={ (e) => this.setState({ searchApprovalDetail: e }) }
                      />
                    </Div>
                  )}
                </Sticky>
                <HourRow { ...this.props } />
                <DataRow
                  { ...this.props }
                  timesheets={ this.props.timesheets }
                  searchApprovalDetail={ this.state.searchApprovalDetail }
                  handleClickCell={ this.handleClickCell }
                />
                <StatusRow />
              </StickyContainer>
            </Content>
          </TabPane>
        )
      }
      default: return (
        <TabPane tabId={ 3 }>
          <CategoryButton
            timesheetStatus={ get(this.props, 'timesheetStatus') }
          />
          <StatusTable
            timesheets={ get(this.props, 'timesheets') }
            timesheetStatus={ timesheetStatus }
            handleClickRow={ (id) => handleClickRequestRow(id) }
          />
        </TabPane>
      )
    }
  }
}

TimesheetStatus.propTypes = {
  handleClickRequestRow: PropTypes.func,
  searchStatus: PropTypes.string,
}
TimesheetStatus.defaultProps = {
  handleClickRequestRow: () => {},
  searchStatus: '',
}

const mapStateToProps = (state, props) => createStructuredSelector({
  getOptionsTimesheetStatus: timesheetSelector.getOptionsTimesheetStatus,
})(state, props)

export default connect(mapStateToProps)(TimesheetStatus)

const Content = styled.div`
  height: calc(100vh - 120px);
  overflow-y: scroll;
  .container {
    height: calc(100vh - 125px);
    background: #EEEEEE;
    max-width: 100% ;
  }
  .gap.tall {
    height: 100%;
  }
  .container.relative {
    overflow-y: auto;
    margin: 0px !important;
    padding: 0px !important;
  }
`
const Div = styled.div`
  height: 40px;
  top: 120px !important;
  z-index: 999 !important;
  background: #EEEEEE;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-status/index.js